import { render, staticRenderFns } from "./Docking.vue?vue&type=template&id=fecccb02&scoped=true"
import script from "./Docking.vue?vue&type=script&lang=js"
export * from "./Docking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecccb02",
  null
  
)

export default component.exports